import { map } from 'lodash';
import { squigglyTemplates } from '../constants/squigglyTemplates';

/**
 * Get squiggly template id
 * @category Getters
 * @category Squiggly
 */
export const getSquigglyTemplateIds = (key: keyof typeof squigglyTemplates) =>
  map(squigglyTemplates[key], 'id');
